"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _makeQueryKey = _interopRequireDefault(require("../../../../utils/make-query-key"));
var _getWebshellclientLocale = _interopRequireDefault(require("../../../../utils/get-webshellclient-locale"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getWishlistQueryKey = function getWishlistQueryKey() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    id = _ref.id;
  var _getWebShellClientLoc = (0, _getWebshellclientLocale["default"])(),
    country = _getWebShellClientLoc.country,
    marketplaceId = _getWebShellClientLoc.marketplaceId;
  var marketplace = marketplaceId || country.toUpperCase();
  return (0, _makeQueryKey["default"])(['buy/wishlists/v2', {
    marketplace: marketplace,
    id: id
  }]);
};
var _default = exports["default"] = getWishlistQueryKey;